exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabs[data-v-19e2d978]{border-bottom:0}", ""]);

// exports
